"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuantityComparatorKind = void 0;
var QuantityComparatorKind;
(function (QuantityComparatorKind) {
    QuantityComparatorKind["_lower"] = "Lower";
    QuantityComparatorKind["_lowerOrEqual"] = "LowerOrEqual";
    QuantityComparatorKind["_greaterOrEqual"] = "GreaterOrEqual";
    QuantityComparatorKind["_greater"] = "Greater";
})(QuantityComparatorKind || (exports.QuantityComparatorKind = QuantityComparatorKind = {}));
//# sourceMappingURL=general.js.map